import { useCallback } from 'react';
import { useAppContext } from '../contexts/AppContext';

export interface NavRule {
  module?: string;
  feature?: string;
}
export const useNavAccess = () => {
  const { hasModule, hasFeature, appReady } = useAppContext();

  const canAccess = useCallback(
    (rule: NavRule): boolean => {
      if (!appReady) return true;
      if (rule.module && !hasModule(rule.module)) return false;
      if (rule.feature && !hasFeature(rule.feature)) return false;
      return true;
    },
    [appReady, hasModule, hasFeature],
  );

  return { canAccess };
};
